<div class="flex gap-2 flex-wrap">

  <div class="grid grid-cols-1 gap-4 p-4">
    @if (upoMissingText()) {
      {{ upoMissingText() }}
    } @else {
      {{ headerText() }}
    }
  </div>

  <div class="flex gap-2 mt-2 flex-wrap w-full justify-end">
    @if (!upoMissingText()) {
      <p-button
        styleClass="customInfoButton outlined"
        label="Wizualizuj UPO"
        (click)="visualizeUpo()">
      </p-button>

      <p-button
        styleClass="customInfoButton outlined"
        label="Eksportuj UPO"
        (click)="exportUpo()">
      </p-button>
    }
    <p-button
      styleClass="customInfoButton"
      label="Zamknij"
      (click)="hidePoswiadczenieStatusDialog()">
    </p-button>
  </div>
</div>
